// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.reporting.admin.CqmReportRequest */
/* istanbul ignore next */
@GandalfModel
export class CqmReportRequest extends GandalfModelBase {

	@GandalfConstantDecorator(constants.CqmSearchTypes)
	@GandalfValidator({ notNull: { message: 'Search Type is required' } })
	@GandalfProperty({ designType: constants.CqmSearchTypes, isRequired: true })
	cqmSearchType!: constants.CqmSearchTypes;

	@GandalfValidator({ notNull: { message: 'End Date is required' } })
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date, isRequired: true })
	endDate!: Date;

	@GandalfValidator({ notNull: { message: 'Provider is Required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	providerId!: number;

	@GandalfValidator({ notNull: { message: 'Start Date is required' } })
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date, isRequired: true })
	startDate!: Date;

}
